module.exports = "<router-outlet></router-outlet>\n<dac-footer></dac-footer>\n<app-login-dialog [fixedBottom]=\"false\"></app-login-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main